/**
 * AUTO-GENERATED by frontend/scripts/blog-sync.mjs.
 * Do not hand-edit — any changes will be overwritten on the next sync.
 *
 * Maps each blog post slug to its meta + a code-split lazy-loaded component.
 */
import { lazy } from 'react';
import type { BlogPostMeta } from './types';
import { meta as m0 } from './posts/how-to-write-a-novel-2026-complete-guide';
import { meta as m1 } from './posts/how-to-write-a-novel-outline-template';
import { meta as m2 } from './posts/sudowrite-alternative-best-ai-novel-writers-2026';

export interface BlogPostEntry {
  meta: BlogPostMeta;
  Component: ReturnType<typeof lazy>;
}

export const BLOG_POSTS: Record<string, BlogPostEntry> = {
  'how-to-write-a-novel-2026-complete-guide': {
    meta: m0,
    Component: lazy(() => import('./posts/how-to-write-a-novel-2026-complete-guide')),
  },
  'how-to-write-a-novel-outline-template': {
    meta: m1,
    Component: lazy(() => import('./posts/how-to-write-a-novel-outline-template')),
  },
  'sudowrite-alternative-best-ai-novel-writers-2026': {
    meta: m2,
    Component: lazy(() => import('./posts/sudowrite-alternative-best-ai-novel-writers-2026')),
  },
};
